<div class="login-container">
  <div class="form-container">
    <h3>Login</h3>

    @if (isLoading) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }



    <form [formGroup]="form">
      <div class="pb-12">
        <div class="custom-icon-input-container">
          <input type="text" formControlName="email" placeholder="Email" autocomplete="email">
          <mat-icon>mail</mat-icon>
        </div>

        @if (form.controls.email.touched) {
          <div class="alert">

            @if (form.controls.email.hasError('email')) {
              <div class="form-validation-error">
                Incorrect email
              </div>
            }
            @if (form.controls.email.hasError('required')) {
              <div class="form-validation-error">
                Required
              </div>
            }
          </div>
        }
      </div>


      <div class="pb-12">
        <div class="custom-icon-input-container">
          <input type="{{isPasswordShown ? 'text' : 'password'}}" formControlName="password" placeholder="Password" autocomplete="password">
          <mat-icon class="pointer" (click)="isPasswordShown = !isPasswordShown">{{isPasswordShown? 'visibility' : 'visibility_off'}}</mat-icon>
        </div>
        @if (form.controls.password.touched) {
          <div class="alert">

            @if (form.controls.password.hasError('required')) {
              <div class="form-validation-error">
                Required
              </div>
            }
          </div>
        }
      </div>
      <button matButton="filled" class="button-regular w-100 pb-12" [disabled]="form.invalid || isLoading" (click)="signInWithEmail()">Login</button>

      <div class="form-footer-block">
        <div class="form-hint">
          <a routerLink="/forgot-password">Forgot Password</a>
        </div>

      </div>

      <div class="form-footer-block">
        <div class="form-hint">
          Do not have account yet?
          <a routerLink="/apply">Apply Now</a>
        </div>

      </div>

    </form>

  </div>

</div>

